import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as fromAfbApi from '../../afb-api/reducers';
import * as fromDashboardDevice from './dashboard-device.reducer';
import * as fromDashboardView from './dashboard-view.reducer';
// import * as fromDashboardGroup from './dashboard-group.reducer';
import * as fromRoot from '../../reducers';
import {Device, DeviceWithUuid} from '../../afb-api/models/device';
import {Snapshot} from '../../shared/models/snapshot';
import {PolledAirDatum} from '../../afb-api/models/air-data';
import {SelfOrganizationUser} from '../../afb-api/models/organization-user';


export interface DashboardState {
  device: fromDashboardDevice.State;
  view: fromDashboardView.State;
  // group: fromDashboardGroup.State;
}

export interface State extends fromRoot.State {
  dashboard: DashboardState;
}

export const reducers: ActionReducerMap<DashboardState> = {
  device: fromDashboardDevice.reducer,
  view: fromDashboardView.reducer
  // group: fromDashboardGroup.reducer
};

export const dashboardState = createFeatureSelector<DashboardState>('dashboard');

/**
 * Dashboard Device State
 */
export const dashboardDeviceState = createSelector(
  dashboardState,
  (state) => state.device
);

export const selectedDeviceUuids = createSelector(
  dashboardDeviceState,
  fromDashboardDevice.selectedDeviceUuids
);
export const deviceSelectionMode = createSelector(
  dashboardDeviceState,
  fromDashboardDevice.deviceSelectionMode
);

export const selectedDeviceEntities = createSelector(
  fromAfbApi.deviceEntities,
  selectedDeviceUuids,
  (deviceEntities: { [deviceUuid: string]: Device }, _selectedDeviceUuids: string[]) =>
    _selectedDeviceUuids.reduce((acc: { [deviceUuid: string]: Device }, selectedDeviceUuid: string) => {
      return {
        ...acc,
        [selectedDeviceUuid]: deviceEntities[selectedDeviceUuid]
      };
    }, {})
);
export const selectedDevices = createSelector(
  fromAfbApi.deviceEntities,
  selectedDeviceUuids,
  (deviceMap: { [deviceUuid: string]: Device }, _selectedDeviceUuids: string[]) => {
    return _selectedDeviceUuids.map((selectedDeviceUuid: string) => deviceMap[selectedDeviceUuid]);
  }
);
export const selectedDevicesWithUuid = createSelector(
  selectedDeviceEntities,
  (entities: { [deviceUuid: string]: Device }) =>
    Object.keys(entities).reduce((devicesWithUuid: DeviceWithUuid[], deviceUuid: string) => [
      ...devicesWithUuid,
      {
        ...entities[deviceUuid],
        uuid: deviceUuid
      }
    ], [])
);


/**
 * Dashboard View State
 */
export const dashboardViewState = createSelector(
  dashboardState,
  (state) => state.view
);

export const selectedListPane = createSelector(
  dashboardViewState,
  fromDashboardView.selectedListPane
);

/**
 * Dashboard Group State
 */
// export const getDashboardGroupState = createSelector(
//   dashboardState,
//   (state) => state.group
// );
// export const selectedGroupId = createSelector(
//   getDashboardGroupState,
//   fromDashboardGroup.selectedGroupId
// );
// export const getSelectedGroup = createSelector(
//   fromRoot.getGroupMap,
//   selectedGroupId,
//   (groupMap: {[groupId: number]: Group}, selectedGroupId: number) => {
//     return groupMap[selectedGroupId];
//   }
// );

/**
 * Hybrid
 */
export const selectedDeviceSnapshots =
  createSelector(selectedDevicesWithUuid, fromAfbApi.airDataPollEntities, fromAfbApi.selfOrganizationUser, (
    _selectedDevices: DeviceWithUuid[],
    polledAirDataEntities: { [deviceUuid: string]: PolledAirDatum },
    selfOrganizationUser: SelfOrganizationUser) => _selectedDevices.reduce((acc: Snapshot[], selectedDevice: DeviceWithUuid) => {
      return [
        ...acc,
        {
          ...polledAirDataEntities[selectedDevice.uuid],
          deviceName: selectedDevice.deviceName,
          deviceType: selectedDevice.deviceType,
          email: selectedDevice.email,
          firstName: selectedDevice.ownerFirstName,
          lastName: selectedDevice.ownerLastName,
          tempUnit: selfOrganizationUser.tempUnit
        }
      ]
    }, [])
  );
